import React from 'react';
import { Container, Button, Card, Row, Col, Badge } from 'react-bootstrap';
import { scrollToTop, handleNavClick } from '../utils/scrollToTop';
import '../App.css';

function Home() {
  return (
    <>
      {/* Modern Hero Section */}
      <section id="home" className="hero-section-modern">
        <div className="hero-background">
          <div className="hero-image-overlay"></div>
          <img 
            src={`${process.env.PUBLIC_URL}/DSC00874.JPG`} 
            alt="DeepJyoti School Students" 
            className="hero-background-image"
          />
          <div className="floating-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
          </div>
        </div>
        <Container className="d-flex align-items-center justify-content-center min-vh-100">
          <div className="hero-content-modern text-center">
            <h1 className="hero-title">
              <span className="title-line-1">DeepJyoti School</span>
            </h1>
            <p className="hero-subtitle"> A Deepak Foundation Initiative</p>
          </div>
        </Container>
        <div className="scroll-indicator">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
        </div>
      </section>

      {/* Banner Section */}
      <section className="banner-section">
        <div className="banner-container">
          <div className="banner-overlay"></div>
          <img 
            src={`${process.env.PUBLIC_URL}/Banner.png`} 
            alt="DeepJyoti School Banner" 
            className="banner-image"
          />
        </div>
      </section>

      {/* Stats Section - Inspired by Kanakia Schools */}
      <section className="stats-section py-5">
        <Container>
          <Row className="g-4 text-center">
            <Col md={4}>
              <div className="stat-card">
                <div className="stat-number">15+</div>
                <div className="stat-label">Years of Excellence</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="stat-card">
                <div className="stat-number">50+</div>
                <div className="stat-label">Educators</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="stat-card">
                <div className="stat-number">2000+</div>
                <div className="stat-label">Learners</div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* About Section */}
      <section id="about" className="section-modern py-5">
        <Container>
          <div className="section-header text-center mb-5">
            <Badge bg="primary" className="section-badge mb-3">About Us</Badge>
            <h2 className="section-title">Where Curiosity Meets Academic Excellence!</h2>
            <p className="section-subtitle">Welcome to DeepJyoti School</p>
          </div>
          
          <Row className="mb-5">
            <Col lg={12}>
              <Card className="card-modern-intro border-0 shadow-sm">
                <Card.Body className="p-4">
                  <Card.Text className="intro-text">
                    DeepJyoti School, a Deepak Foundation Initiative, located in Mira Road East, Thane, is a renowned educational institution 
                    catering to the academic needs of students in the area. With a strong focus on holistic 
                    development and academic excellence, the school has established itself as a trusted name 
                    in the education sector.
                  </Card.Text>
                  <Card.Text className="intro-text">
                    DeepJyoti School is committed to providing quality education and nurturing young minds. 
                    The school offers a comprehensive curriculum that integrates academic learning with 
                    co-curricular activities, ensuring the overall development of students. With a team of 
                    dedicated educators and state-of-the-art facilities, DeepJyoti School strives to create 
                    a conducive learning environment where students can thrive academically and personally.
                  </Card.Text>
                  <Card.Text className="intro-text">
                    At DeepJyoti School, our goal is to translate a simple yet powerful idea into reality: 
                    to empower young minds to thrive in a rapidly changing world. We achieve this by fostering 
                    a nurturing environment where students discover their passions, develop their talents, 
                    and become compassionate, responsible global citizens.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Mission & Vision Section */}
          <Row className="g-4 mb-5">
            <Col md={6}>
              <Card className="card-modern card-modern-1 h-100">
                <Card.Body className="p-4">
                  <Card.Title className="card-title-modern mb-3">Our Mission</Card.Title>
                  <Card.Text className="card-text-modern">
                    Our Mission is to inspire young minds to meet their full potential as learners. We intend 
                    to create a supportive educational environment that produces self-motivated students and 
                    reliable future citizens.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="card-modern card-modern-2 h-100">
                <Card.Body className="p-4">
                  <Card.Title className="card-title-modern mb-3">Our Vision</Card.Title>
                  <Card.Text className="card-text-modern">
                    Our Vision is to develop global leaders for tomorrow. We aspire to develop our students 
                    into lifelong learners with a sense of purpose, good moral judgement and commitment to 
                    making the world a better place for all.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Key Highlights Section */}
          <div className="key-highlights-section">
            <h3 className="text-center mb-4" style={{ fontFamily: "'Poppins', 'Roboto', sans-serif", fontWeight: 700 }}>Key Highlights: What Makes Us Special</h3>
            <Row className="g-3">
              <Col md={6} lg={4}>
                <div className="highlight-item">
                  <span>15+ years of educational excellence</span>
                </div>
              </Col>
              <Col md={6} lg={4}>
                <div className="highlight-item">
                  <span className="highlight-icon">✓</span>
                  <span>Focus on holistic development</span>
                </div>
              </Col>
              <Col md={6} lg={4}>
                <div className="highlight-item">
                  <span className="highlight-icon">✓</span>
                  <span>Spacious and bright classrooms</span>
                </div>
              </Col>
              <Col md={6} lg={4}>
                <div className="highlight-item">
                  <span className="highlight-icon">✓</span>
                  <span>Numerous extracurricular activities</span>
                </div>
              </Col>
              <Col md={6} lg={4}>
                <div className="highlight-item">
                  <span className="highlight-icon">✓</span>
                  <span>Excellent academic track record</span>
                </div>
              </Col>
              <Col md={6} lg={4}>
                <div className="highlight-item">
                  <span className="highlight-icon">✓</span>
                  <span>Dedicated, experienced faculty</span>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      {/* Values Section */}
      <section className="section-modern section-programs py-5">
        <Container>
          <div className="section-header text-center mb-5">
            <Badge bg="warning" className="section-badge mb-3">Our Values</Badge>
            <h2 className="section-title">DeepJyoti School Values</h2>
            <p className="section-subtitle">Our values serve as the compass guiding our pursuit of academic excellence</p>
          </div>
          <Row className="g-4">
            <Col md={6} lg={3}>
              <Card className="card-value h-100 text-center">
                <Card.Body className="p-4">
                  <Card.Title className="value-title mb-3">Empathy</Card.Title>
                  <Card.Text className="value-text">
                    Understanding and sharing the feelings of others, fostering compassion and kindness.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="card-value h-100 text-center">
                <Card.Body className="p-4">
                  <Card.Title className="value-title mb-3">Resourcefulness</Card.Title>
                  <Card.Text className="value-text">
                    Finding creative solutions and making the most of available resources.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="card-value h-100 text-center">
                <Card.Body className="p-4">
                  <Card.Title className="value-title mb-3">Assertiveness</Card.Title>
                  <Card.Text className="value-text">
                    Confidently expressing ideas and standing up for what is right.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="card-value h-100 text-center">
                <Card.Body className="p-4">
                  <Card.Title className="value-title mb-3">Humbleness</Card.Title>
                  <Card.Text className="value-text">
                    Maintaining modesty and respect while achieving excellence.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Facilities Section */}
      <section id="facilities" className="section-modern py-5">
        <Container>
          <div className="section-header text-center mb-5">
            <Badge bg="success" className="section-badge mb-3">Facilities</Badge>
            <h2 className="section-title">Facilities Offered</h2>
            <p className="section-subtitle">State-of-the-art infrastructure supporting excellence in learning</p>
          </div>
          <Row className="g-4">
            <Col md={6} lg={4}>
              <Card className="card-program h-100">
                <Card.Body className="p-4">
                  <Card.Title className="program-title mb-3">Modern Classrooms</Card.Title>
                  <Card.Text className="program-text">
                    Well-equipped classrooms with modern teaching aids to enhance the learning experience 
                    and facilitate interactive teaching methods.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-program h-100">
                <Card.Body className="p-4">
                  <Card.Title className="program-title mb-3">Science & Computer Labs</Card.Title>
                  <Card.Text className="program-text">
                    Science and computer laboratories for practical learning, enabling students to 
                    apply theoretical knowledge through hands-on experiments and activities.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-program h-100">
                <Card.Body className="p-4">
                  <Card.Title className="program-title mb-3">Library</Card.Title>
                  <Card.Text className="program-text">
                    Library with a vast collection of books and reference materials to encourage 
                    reading habits and support research activities.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-program h-100">
                <Card.Body className="p-4">
                  <Card.Title className="program-title mb-3">Sports Facilities</Card.Title>
                  <Card.Text className="program-text">
                    Playground and sports facilities to encourage physical fitness and promote 
                    teamwork through various sports activities.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-program h-100">
                <Card.Body className="p-4">
                  <Card.Title className="program-title mb-3">Art & Music Rooms</Card.Title>
                  <Card.Text className="program-text">
                    Art and music rooms to foster creativity and provide students with opportunities 
                    to explore their artistic talents.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-program h-100">
                <Card.Body className="p-4">
                  <Card.Title className="program-title mb-3">Transportation</Card.Title>
                  <Card.Text className="program-text">
                    Transportation services for safe and convenient commuting, ensuring students 
                    can travel to and from school comfortably.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Teaching Methodology Section */}
      <section id="programs" className="section-modern section-programs py-5">
        <Container>
          <div className="section-header text-center mb-5">
            <Badge bg="info" className="section-badge mb-3">Teaching Methodology</Badge>
            <h2 className="section-title">Innovative Teaching Approaches</h2>
            <p className="section-subtitle">Creating an engaging and effective learning environment</p>
          </div>
          <Row className="g-4">
            <Col md={6} lg={4}>
              <Card className="card-modern h-100">
                <Card.Body className="p-4">
                  <Card.Title className="card-title-modern mb-3">Interactive Sessions</Card.Title>
                  <Card.Text className="card-text-modern">
                    Interactive classroom sessions to encourage student participation and active learning, 
                    making education more engaging and effective.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-modern h-100">
                <Card.Body className="p-4">
                  <Card.Title className="card-title-modern mb-3">Experiential Learning</Card.Title>
                  <Card.Text className="card-text-modern">
                    Experiential learning through hands-on activities and experiments, allowing students 
                    to learn by doing and understand concepts deeply.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-modern h-100">
                <Card.Body className="p-4">
                  <Card.Title className="card-title-modern mb-3">Technology Integration</Card.Title>
                  <Card.Text className="card-text-modern">
                    Use of technology to enhance teaching and learning processes, preparing students 
                    for the digital age.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-modern h-100">
                <Card.Body className="p-4">
                  <Card.Title className="card-title-modern mb-3">Regular Assessments</Card.Title>
                  <Card.Text className="card-text-modern">
                    Regular assessments to track the progress of students and identify areas that need 
                    improvement or additional support.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-modern h-100">
                <Card.Body className="p-4">
                  <Card.Title className="card-title-modern mb-3">Individual Attention</Card.Title>
                  <Card.Text className="card-text-modern">
                    Individual attention to cater to the unique learning needs of each student, ensuring 
                    personalized growth and development.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-modern h-100">
                <Card.Body className="p-4">
                  <Card.Title className="card-title-modern mb-3">Holistic Development</Card.Title>
                  <Card.Text className="card-text-modern">
                    Comprehensive curriculum that integrates academic learning with co-curricular activities 
                    for overall student development.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Co-curricular Activities Section */}
      <section className="section-modern py-5">
        <Container>
          <div className="section-header text-center mb-5">
            <Badge bg="secondary" className="section-badge mb-3">Activities</Badge>
            <h2 className="section-title">Co-curricular Activities</h2>
            <p className="section-subtitle">Holistic development through diverse activities</p>
          </div>
          <Row className="g-4">
            <Col md={6} lg={4}>
              <Card className="card-program h-100">
                <Card.Body className="p-4">
                  <Card.Title className="program-title mb-3">Sports & Athletics</Card.Title>
                  <Card.Text className="program-text">
                    Sports and athletics to promote physical fitness and teamwork, building character 
                    and discipline among students.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-program h-100">
                <Card.Body className="p-4">
                  <Card.Title className="program-title mb-3">Art & Craft</Card.Title>
                  <Card.Text className="program-text">
                    Art and craft activities to nurture creativity and artistic expression, allowing 
                    students to explore their creative potential.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-program h-100">
                <Card.Body className="p-4">
                  <Card.Title className="program-title mb-3">Music, Dance & Drama</Card.Title>
                  <Card.Text className="program-text">
                    Music, dance, and drama to encourage self-expression and build confidence through 
                    performing arts.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-program h-100">
                <Card.Body className="p-4">
                  <Card.Title className="program-title mb-3">Debates & Competitions</Card.Title>
                  <Card.Text className="program-text">
                    Debates, quizzes, and elocution competitions to enhance communication skills and 
                    critical thinking abilities.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-program h-100">
                <Card.Body className="p-4">
                  <Card.Title className="program-title mb-3">Community Service</Card.Title>
                  <Card.Text className="program-text">
                    Social initiatives and community service programs to instill values of empathy 
                    and social responsibility.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="card-program h-100">
                <Card.Body className="p-4">
                  <Card.Title className="program-title mb-3">Leadership Programs</Card.Title>
                  <Card.Text className="program-text">
                    Various leadership opportunities and programs designed to develop leadership 
                    qualities and civic engagement among students.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact Section */}
      <section id="contact" className="section-modern section-contact py-5">
        <Container>
          <div className="section-header text-center mb-5">
            <Badge bg="info" className="section-badge mb-3">Contact Us</Badge>
            <h2 className="section-title">Get in Touch</h2>
            <p className="section-subtitle">We'd love to hear from you and answer any questions</p>
          </div>
          <Row className="g-4 mb-4">
            <Col md={4}>
              <Card className="card-contact h-100 text-center">
                <Card.Body className="p-4">
                  <Card.Title className="contact-title mb-3">Location</Card.Title>
                  <Card.Text className="contact-text">
                    Mira Road East<br />
                    Thane, Maharashtra<br />
                    India
                  </Card.Text>
                  <a 
                    href="https://maps.app.goo.gl/cSkkRSbR8qRaqjST6" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-light btn-sm mt-3"
                  >
                    View on Google Maps
                  </a>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="card-contact h-100 text-center">
                <Card.Body className="p-4">
                  <Card.Title className="contact-title mb-3">Phone</Card.Title>
                  <Card.Text className="contact-text">
                    7208282855<br />
                    7045646649<br />
                    <small className="text-muted">Mon-Fri: 9:00 AM - 4:00 PM</small>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="card-contact h-100 text-center">
                <Card.Body className="p-4">
                  <Card.Title className="contact-title mb-3">Email</Card.Title>
                  <Card.Text className="contact-text">
                    reachus@deepjyotischool.org
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8}>
              <Card className="card-contact-action border-0">
                <Card.Body className="p-4 text-center">
                  <h5 className="mb-4">Connect With Us</h5>
                  <div className="d-flex gap-3 justify-content-center flex-wrap">
                    <a 
                      href="https://www.instagram.com/deepjyotischool?igsh=MWxxNGNqMXlidWJtdA==" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-outline-light btn-lg action-btn"
                    >
                      <i className="fab fa-instagram me-2"></i> Instagram
                    </a>
                    <a 
                      href="https://www.facebook.com/share/1691ga4NEV/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-outline-light btn-lg action-btn"
                    >
                      <i className="fab fa-facebook me-2"></i> Facebook
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Home;
